module.exports = __webpack_public_path__ + "static/media/user-profile.73e40065.PNG";